import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import React from "react";
import DashboardPage from "../pages/DashboardPage";
import LoginPage from "../pages/LoginPage";

import PricePlanPage from "../pages/PricePlanPage";
import ScriptDetailPage from "../pages/scriptdetail/ScriptDetailPage";
import ModulesDetailPage from "../pages/ModulesDetailPage/ModulesDetailPage";

//User
import UserGroupPage from "../pages/user/UserGroup/UserGroupPage";
import ViewUserGroupPage from "../pages/user/UserGroup/ViewUserGroupPage";
import UserRegistrationPage from "../pages/user/UserRegistrationPage";
import ChangePasswordPage from "../pages/user/ChangePasswordPage";
//Client
import ClientRegistrationPage from "../pages/client/ClientRegistrationPage";
import ClientRegistrationPageForOtherSoftware from "../pages/client/ClientRegistrationPageForOtherSoftware";
import ClientListPage from "../pages/client/CLientListPage";
import UpdateClientPage from "../pages/client/UpdateClientPage";
import MaintainanceModePage from "../pages/client/MaintainanceModePage";
import ClientPaymentPage from "../pages/client/ClientPaymentPage";
import PublishNoticePage from "../pages/client/PublishNoticePage";
//Reports
import ClientPaymenReportPage from "../pages/reports/ClientPaymenReportPage";
import ClientLedgerReportPagePage from "../pages/reports/ClientLedgerReportPage";
import MarketingAgentPage from "../pages/user/MarketingAgentPage";


//scripts
import RunfreshDataPage from '../pages/RunfreshDataPage'
import RunfreshScriptPage from '../pages/RunfreshScriptPage'

//Ticket
import TicketDetailPage from "../pages/ticketdetail/TicketDetailPage";
import PriorityDetailPage from "../pages/prioritydetail/PriorityDetailPage";
import TicketTypeDetailPage from "../pages/ticketypedetail/TicketTypeDetailPage";
import TicketStatusDetailPage from "../pages/ticketstatusdetail/TicketStatusDetail";
import ProjectDetailPage from "../pages/projectdetail/ProjectDetailPage";
import VersionDetailPage from "../pages/verisondetail/VersionDetailPage";
import UpdateDetailPage from "../pages/updatedetail/UpdateDetailPage";
import TimesheetSystemPage from "../pages/TimesheetSystem/TimesheetSystemPage";
import TimesheetSystemApprovalPage from "../pages/TimesheetSystem/TimesheetSystemApprovalPage"
import TimesheetSystemReportPage from "../pages/TimesheetSystem/TimesheetSystemReportPage";


export default function Routes() {
  return (
    <div>
      <Router>
        <Switch>
          <Route path='/dashboard'>
            <DashboardPage />
          </Route>
          <Route path='/priceplan'>
            <PricePlanPage />
          </Route>
          <Route path='/script-detail-page'>
            <ScriptDetailPage />
          </Route>
          <Route path='/modules-detail-page'>
            <ModulesDetailPage />
          </Route>
          {/* Ticket */}
          <Route path='/timesheet-system-page'>
            <TimesheetSystemPage />
          </Route>
          <Route path='/timesheet-system-approval-page'>
            <TimesheetSystemApprovalPage/>
          </Route>
          <Route path='/timesheet-system-report-page'>
            <TimesheetSystemReportPage />
          </Route>
          <Route path='/ticketing-detail-page'>
            <TicketDetailPage />
          </Route>
          <Route path='/priority-detail-page'>
            <PriorityDetailPage />
          </Route>
          <Route path='/project-detail-page'>
            <ProjectDetailPage />
          </Route>
          <Route path='/ticket-type-detail-page'>
            <TicketTypeDetailPage />
          </Route>
          <Route path='/ticket-status-detail-page'>
            <TicketStatusDetailPage />
          </Route>
          <Route path='/version-detail-page'>
            <VersionDetailPage />
          </Route>
          <Route path='/update-detail-page'>
            <UpdateDetailPage />
          </Route>

          {/* //Client */}
          <Route path='/client-registration'>
            <ClientRegistrationPage />
          </Route>
          <Route path='/client-registration-for-other-software'>
            <ClientRegistrationPageForOtherSoftware/>
          </Route>
          <Route path='/client-list'>
            <ClientListPage />
          </Route>
          <Route path='/update-client/:id'>
            <UpdateClientPage />
          </Route>
          <Route path='/publish-notice/'>
            <PublishNoticePage />
          </Route>
          <Route path='/activate-maintaince-mode'>
            <MaintainanceModePage />
          </Route>
          <Route path='/client-payment'>
            <ClientPaymentPage />
          </Route>
          {/* User */}
          <Route path='/create-user-group'>
            <UserGroupPage />
          </Route>
          <Route path='/view-user-group'>
            <ViewUserGroupPage />
          </Route>
          <Route path='/user-registration'>
            <UserRegistrationPage />
          </Route>
          <Route path='/marketing-agent'>
            <MarketingAgentPage />
          </Route>
          <Route path='/change-password'>
            <ChangePasswordPage />
          </Route>

          {/*routes for script */}

          <Route path="/runfreshdata" exact>
            <RunfreshDataPage />
          </Route>

          <Route path="/runfreshscript" exact>
            <RunfreshScriptPage />
          </Route>


          {/* Reports */}
          <Route path='/client-payment-report'>
            <ClientPaymenReportPage />
          </Route>
          <Route path='/client-ledger-report'>
            <ClientLedgerReportPagePage />
          </Route>
          <Route path='/'>
            <LoginPage />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}
